import { render, staticRenderFns } from "./ChallengeEquipe.vue?vue&type=template&id=d9be871a"
import script from "./ChallengeEquipe.vue?vue&type=script&lang=js"
export * from "./ChallengeEquipe.vue?vue&type=script&lang=js"
import style0 from "./ChallengeEquipe.vue?vue&type=style&index=0&id=d9be871a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports